import wrapWithProvider from "components/Root"
export const wrapRootElement = wrapWithProvider
